// export const baseurl='https://yibiaotianxia.junhekh.cn/v1/'
export const baseurl='https://yibiaotianxia.cn/v1/'
// export const imgurl='https://yibiaotianxia.junhekh.cn/'
import axios from "axios";
import qs from 'qs'
import { Loading } from 'element-ui';


const requestget=(url,params)=>{
    // console.log(params)
    return new Promise((resolve, reject) => {
        let loadingInstance = Loading.service();
        axios.get( baseurl+url,{params}).then(res=>{
            loadingInstance.close();
            resolve(res.data)
        }).catch(res=>{
            loadingInstance.close();
            reject(res)
        })
    })
}
const requestpost=(url,params)=>{
    // console.log( data )
    return new Promise((resolve, reject) => {
        let loadingInstance = Loading.service();
        axios({
            url:baseurl+url,
            method:'post',
            params
          }).then(res=>{
                loadingInstance.close();
                resolve(res)
            }).catch(res=>{
                loadingInstance.close();
                reject(res)
            })
        // axios.post( baseurl+url,data,{
           
        // }).then(res=>{
        //     // resolve(res.data)
        //     resolve(reject)
        // })
    })
}
export const tokens=()=>{
    return  localStorage.getItem('token')
}

 const mylogin=(data)=>requestpost(data.url,data.data)
 const login=(data)=>requestget(data.url,data.params)
//  const login=(data)=>requestget(data.url,data.data)
// 首页
export function pc_index(params){
    return login({
        url:'pc_index',
        params
    })
}

// 行业资讯
export function sort(params){
    return login({
        url:'sort',
		params
    })
}

// 行业资讯 分类列表
export function sort_list(params){
    // console.log(params,'par')
    return login({
        url:'sort_list',
        params
    })
}

// 行业资讯 分类详情
export function sort_info(params){
    return login({
        url:'sort_info',
        params
    })
}

// 收藏
export function collect(params){
    let token=tokens()
    return mylogin({
        url:'collect',
        data:{token,...params}

    })
}

// 取消收藏
export function del_collect(params){
    let token=tokens()
    return mylogin({
        url:'del_collect',
        data:{token,...params}

    })
}

// 行业资讯 分类详情
// export function sort(params){
//     return login({
//         url:'sort',
//         params
//     })
// }

// mobile_login
// 账号密码登录
export function mobile_login(data){
    // let token=tokens()
    return mylogin({
        url:'mobile_login',
        data
    })
}


// 专业服务 分类
export function service(params){
    return login({
        url:'service',
        params
    })
}

// 专业服务 分类列表
export function service_list(params){
    return login({
        url:'service_list',
        params
    })
}

// 专业服务 分类列表详情
export function service_info(params){
    return login({
        url:'service_info',
        params
    })
}


// 仪表商城
export function shop(params){
    return login({
        url:'shop',
        params
    })
}



// 仪表天下分类列表 
export function shop_list(params){
    return login({
        url:'shop_list',
        params
    })
}

// 仪表天下分类列表 
export function shop_info(params){
    return login({
        url:'shop_info',
        params
    })
}

// 供应商列表 
export function supplier(params){
    return login({
        url:'supplier',
        params
    })
}

// 供应商详情 
export function supplier_info(params){
    return login({
        url:'supplier_info',
        params
    })
}


export function send_mobile(data){
    // let token=tokens()
    return mylogin({
        url:'send_mobile',
        data
    })
}

// 专业服务 分类列表详情中的表单
export function service_order(params){
    let token=tokens()
    return mylogin({
        url:'service_order',
        data:{token,...params}
    })
}

//  专业服务 电话登记
export function service_num(data){

    return mylogin({
        url:'service_num',
        data:{...data}
    })
}

//  仪表天下 订购登记
export function shop_order(data){
    let token=tokens()
    return mylogin({
        url:'shop_order',
        data:{token,...data}
    })
}

//  仪表天下 电话登记
export function mobile_num(data){
    return mylogin({
        url:'mobile_num',
        data:{...data}
    })
}

// 搜索类型
export function search_type(){
    return login({
        url:'search_type',
    })
}

// 搜索类型
export function search_trade(params){
    return login({
        url:'search_trade',
        params
    })
}

// 热门词汇
export function hot_key(params){
    return login({
        url:'hot_key',
        params
    })
}

// 服务搜索列表
export function search_service(params){
    return login({
        url:'search_service',
        params
    })
}

// 仪器搜索列表
export function search_shop(params){
    return login({
        url:'search_shop',
        params
    })
}

// 用户信息
export function user(params){
    let token=tokens()
    return login({
        url:'user',
        params:{token,...params}
    })
}

// 修改用户资料
export function user_update(data){
    let token=tokens()
    return mylogin({
        url:'user_update',
        data:{token,...data}
    })
}

// 我的收藏
export function my_collect(params){
    let token=tokens()
    return login({
        url:'my_collect',
        params:{token,...params}
    })
}



// 意见反馈
export function feedback(data){
    let token=tokens()
    return mylogin({
        url:'feedback',
        data:{token,...data}
    })
}

// 我的 协议
export function agreement(params){
    let token=tokens()
    return login({
        url:'agreement',
        params:{token,...params}
    })
}

// 入驻申请
export function settel(data){
    let token=tokens()
    return mylogin({
        url:'settel',
        data:{token,...data}
    })
}

// 我的 申请
export function settel_list(params){
    let token=tokens()
    return login({
        url:'settel_list',
        params:{token,...params}
    })
}

// 我的 申请详情
export function settel_info(params){
    let token=tokens()
    return login({
        url:'settel_info',
        params:{token,...params}
    })
}

// 我的 列表
export function notice_list(params){
    let token=tokens()
    return login({
        url:'notice_list',
        params:{token,...params}
    })
}

// 我的 列表 详情
export function notice_info(params){
    let token=tokens()
    return login({
        url:'notice_info',
        params:{token,...params}
    })
}

// 我的 我的订购
export function my_order(params){
    let token=tokens()
    return login({
        url:'my_order',
        params:{token,...params}
    })
}

// 我的 登记详情
export function my_order_info(params){
    let token=tokens()
    return login({
        url:'my_order_info',
        params:{token,...params}
    })
}

// 手机号验证码注册
export function pc_register(data){
    let token=tokens()
    return mylogin({
        url:'pc_register',
        data:{token,...data}
    })
}

// changepwd
// 忘记密码
export function changepwd(data){
    let token=tokens()
    return mylogin({
        url:'changepwd',
        data:{token,...data}
    })
}

// bind_mobile
// 绑定密码
export function bind_mobile(data){
    let token=tokens()
    return mylogin({
        url:'bind_mobile',
        data:{token,...data}
    })
}

// // notice_list?page=1
// export function notice_list(params){
//     let token=tokens()
//     return login({
//         url:'notice_list',
//         params:{token,...params}
//     })
// }
// http://www.ybtx.com/v1/banner_info?type_list=1&info_id=1
// 轮播图跳转
export function banner_info(data){
    return login({
        url:'banner_info',
        params:{...data}
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js